import Footer from 'pages/Login/footer/styled';

export default Footer;
